import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import About from "./views/About.vue";
import Login from "./views/Login.vue";
import Replacement from "./views/Replacement.vue";
import ReplacementAdd from "./views/ReplacementAdd.vue";
import Replacements from "./views/Replacements.vue";
import Leftovers from "./views/Leftovers.vue";
import Receptions from "./views/Receptions.vue";
import Inventory from "./views/Inventory";
import InventoryView from "./views/InventoryView";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.VUE_APP_BASE_URL,
  linkExactActiveClass: "router-link-is-active",
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/inventory",
      name: "inventory",
      component: Inventory,
    },
    {
      path: "/about",
      name: "about",
      component: About,
    },
    {
      path: "/login",
      name: "login",
      component: Login,
    },
    {
      path: "/replacement/:id",
      name: "replacement",
      component: Replacement,
    },
    {
      path: "/replacements",
      name: "replacements",
      component: Replacements,
    },
    {
      path: "/leftovers",
      name: "leftovers",
      component: Leftovers,
    },
    {
      path: "/receptions",
      name: "receptions",
      component: Receptions,
    },
    {
      path:
        "/replacement/order/:orderId/:orderNumber/cart/:cartNumber/article/:article/size/:size",
      name: "replacementForArticle",
      component: ReplacementAdd,
    },
    {
      path: "/inventory/:docId",
      name: "viewInventoryDocument",
      component: InventoryView,
    },
  ],
});
